import { Component } from '@angular/core';

@Component({
  selector: 'app-card-demo-api-spec',
  imports: [],
  templateUrl: './card-demo-api-spec.component.html',
  styleUrl: './card-demo-api-spec.component.scss',
})
export class CardDemoApiSpecComponent {}
